import DataListingTable from 'components/DataListingTable'
import { DEFAULT_PAGE_SIZE } from 'constants/pagination'
import localStorage from 'helpers/localStorage'
import React, { useEffect, useMemo, useState } from 'react'
import { toast } from 'react-toastify'
import { Flex } from 'reflexbox/styled-components'
import packagesBalanceService from 'services/packagesBalance'

const PartnerMyPackagesTable = () => {
  const [packagesBalance, setPackagesBalance] = useState([])
  const [sortBy, setSortBy] = useState(null)
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: localStorage.get('pageSize', DEFAULT_PAGE_SIZE),
    totalPages: 1,
    totalRecords: 0,
  })
  const [isLoading, setLoading] = useState(true)

  const columns = useMemo(
    () => [
      {
        Header: 'Pacote',
        accessor: 'package',
        disableSortBy: true,
      },
      {
        Header: 'Saldo',
        accessor: 'balance',
      },
      {
        Header: 'Consumo para 1 dia',
        accessor: 'consumption_1_day',
      },
      {
        Header: 'Consumo para 7 dias',
        accessor: 'consumption_7_days',
      },
      {
        Header: 'Consumo para 30 dias',
        accessor: 'consumption_1_month',
      },
    ],
    [],
  )

  const handleTableDataFetch = ({ sortBy, currentPage, pageSize }) => {
    setSortBy(sortBy)
    setPagination({ ...pagination, currentPage, pageSize })
  }

  const fetchPackagesBalance = async () => {
    setLoading(true)

    try {
      const response = await packagesBalanceService.fetchAll({
        sortBy,
        pagination,
      })

      response.packagesBalance.map(item => (item.balance = item.balance < 0 ? 0 : item.balance))

      setPackagesBalance(response.packagesBalance)
      setPagination(response.pagination)
    } catch (e) {
      console.log(e)
      toast.error('Ocorreu algum erro no carregamento dos dados')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (sortBy) {
      fetchPackagesBalance()
    }
  }, [sortBy, pagination.currentPage, pagination.pageSize])

  useEffect(() => {
    localStorage.set('pageSize', pagination.pageSize)
  }, [pagination.pageSize])

  return (
    <Flex flexDirection='column' width='100%'>
      <DataListingTable
        data={packagesBalance}
        columns={columns}
        pagination={pagination}
        loading={isLoading}
        fetchData={handleTableDataFetch}
      />
    </Flex>
  )
}

export default PartnerMyPackagesTable
